import TransitionLink from "~/components/atoms/TransitionLink"
import DetailedExplanationList from "~/components/molecules/DetailedExplanationList"
import { CompanyForNewGradJobDetail } from "~/entities/Company"
import { internalLink } from "~/services/helper"

import * as styled from "./styled"

interface Props {
  company: CompanyForNewGradJobDetail
  showMore?: boolean
}

const Company = ({ company, showMore }: Props) => {
  return (
    <styled.EachTabContainer>
      <div className="content-wrapper">
        <DetailedExplanationList
          direction="Horizontal"
          heading="会社概要"
          items={[
            {
              heading: "企業名",
              description: company.name,
            },
            {
              heading: "目指していること",
              description: company.mission,
            },
            {
              heading: "事業内容",
              description: company.company_overview,
            },
            {
              heading: "社風・風土",
              description: company.culture,
            },
            {
              heading: "従業員規模 (単位: 名)",
              description: `${company.employee_number_range}`,
            },
            {
              heading: "設立",
              description: company.established_on,
            },
            {
              heading: "所在地",
              description: `${company.prefecture}${company.address1}${company.address2}${company.address3 || ""}`,
            },
          ]}
        />
        {showMore && (
          <TransitionLink
            isButton
            className="company-more-link"
            size="Large"
            icon="Next"
            href={internalLink("/companies/[company-id]")}
            dynamicRoutePath={internalLink(`/companies/${company.id}`)}
          >
            この会社をもっと見る
          </TransitionLink>
        )}
      </div>
    </styled.EachTabContainer>
  )
}

export default Company
